const generateSectionsData = (text_dic) => ({
    A3: {
      title: "Proje Kısa Tanımı",
      content: {
        PURPOSE: { title: "Projenin Amacı", content_text: text_dic.PURPOSE, max_chars: 1000 },
        // KEYWORDS: { title: "Anahtar Kelimeler", content_text: text_dic.KEYWORDS },
        NOVEL_ASPECTS: { title: "Yenilikçi Yönleri", content_text: text_dic.NOVEL_ASPECTS, max_chars: 700 },
        IMPACT: { title: "Ekonomik ve Ulusal Kazanımlar", content_text: text_dic.IMPACT, max_chars: 1000 },
        PRIORITY: { title: "Öncelikli ve Kilit Teknolojiler", content_text: text_dic.PRIORITY },
        REASON_PRIORITY: { title: "Öncelikli Alan Gerekçesi", content_text: text_dic.REASON_PRIORITY, max_chars: 1000 }
      },
    },
    B1: {
        title: "Projenin Hedefleri",
        content: {
            PROBLEM: { title: "Problem Tanımı", content_text: text_dic.PROBLEM, max_chars: 10000 },
            METHOD: { title: "Çözüm Önerisi", content_text: text_dic.METHOD, max_chars: 10000 },
            TARGETS: { title: "Ulaşılması Planlanan Hedefler", content_text: text_dic.TARGETS, max_chars: 10000 },
            MARKET: { title: "Hedef Kitle", content_text: text_dic.MARKET, max_chars: 10000 }
        },
    },
    B2: {
        title: "Projenin Teknoloji Düzeyi",
        content: {
            SOTA: { title: "Tekniğin/Teknolojinin Bilinen Güncel Durumu (State-of-the-Art)", content_text: text_dic.SOTA, max_chars: 3000 },
            CONTRIBUTIONS: { title: "Proje Faaliyetlerinin Kapsadığı Teknik ve Teknolojiler ile Özgün Katkılar", content_text: text_dic.CONTRIBUTIONS, max_chars: 5000 },
            DIFFICULTIES: { title: "Teknik/Teknolojik Belirsizlik ve Zorluklar", content_text: text_dic.DIFFICULTIES, max_chars: 3000 }
        },
    },
    B3: {
        title: "Projenin Somut / Ölçülebilir Hedeflerle Tanıtımı ve Çözüm Yaklaşımları (Ar-Ge Sistematiği)",
        content: {
            SPECIFIC_TARGETS: { title: "Proje Hedefleri", content_text: text_dic.SPECIFIC_TARGETS, max_chars: 10000 },
            PRIOR_WORK: { title: "Proje Hazırlık Çalışmaları", content_text: text_dic.PRIOR_WORK, max_chars: 500 },
            //PRIOR_PATENT: { title: "Proje konusu ile ilişkili –varsa- patent/faydalı model araştırması sonuçları", content_text: "Henüz IDEATRUM tarafından yazılmamaktadır.", max_chars: 500 },
            SUMMARY_PRIOR_WORK: { title: "Teknik ön fizibilite çalışmalarının –yapıldı ise- özet bulguları", content_text: text_dic.SUMMARY_PRIOR_WORK, max_chars: 1500 },
            STANDARDS: { title: "Proje çıktısına ilişkin takip edilecek standartlar / şartnameler", content_text: text_dic.STANDARDS, max_chars: 1500 },
            RD_METHODS: { title: "Ar-Ge Sürecinde Kullanılacak Yöntemler", content_text: text_dic.RD_METHODS, max_chars: 3000 }
        },
    },
    B4: {
        title: "Projenin Yenilikçi Yönleri",
        content: {
            NOVELTY: { title: "Yenilikler", content_text: text_dic.NOVELTY, max_chars: 3000 },
            /*OWN_PRODUCTS: { title: "Kuruluşumuzun Benzer Ürün/Süreçlerle Kıyaslama", content_text: text_dic.OWN_PRODUCTS },*/
            PRODUCTS: { title: "Proje Çıktısının Yurtiçi/Yurtdışı Pazardaki Mevcut veya Potansiyel Benzerleri ile Kıyaslama", content_text: text_dic.PRODUCTS }
        },
    },
    C1: {
        title: "İş Planı",
        content: {
            /*TASKS: {title: "İş Paketleri", content_text: text_dic.TASKS},
            SUBTASKS: { title: "İş Paketi Faaliyetleri", content_text: text_dic.SUBTASKS },
            WP: { title: "Kullanılacak Yöntemler", content_text: text_dic.WP },
            EXPERIMENTS: { title: "İş Paketindeki Deney, Test ve Analizleri", content_text: text_dic.EXPERIMENTS },
            OUTCOMES: { title: "Ara Çıktılar Listesi", content_text: text_dic.OUTCOMES }*/
            TASKS: {title: "İş Paketleri", content_text: text_dic.TASKS},
        },
    },
    /*C2: {
        title: "Proje Yönetimi ve Organizasyonu",
        content: {
            MANAGEMENT: { title: "Yönetim Planı", content_text: text_dic.MANAGEMENT, max_chars: 2500 }
        },
    },*/
    /*C3: {
        title: "C.3. Kuruluş Altyapısı",
        content: {
            FACILITIES: { title: "AR-GE Olanakları", content_text: text_dic.FACILITIES }
        },
    },*/
    D1: {
        title: "Pazar Fırsatı",
        content: {
            MARKET_SIZE: { title: "Pazar Büyüklüğü", content_text: text_dic.MARKET_SIZE, max_chars: 3000 },
            CUSTOMER_DEFINITION: { title: "Müşteri Tanımı", content_text: text_dic.MARKET_SIZE, max_chars: 3000 },
            CUSTOMER_NEEDS: { title: "Müşteri İhtiyaçları", content_text: text_dic.CUSTOMER_NEEDS, max_chars: 3000 },
            BUSINESS_MODEL: { title: "İş Modeli", content_text: text_dic.BUSINESS_MODEL, max_chars: 3000 },
            CUSTOMER_ACCESS: { title: "Müşteriye Erişim", content_text: text_dic.CUSTOMER_ACCESS, max_chars: 3000 },
            COMPETITIVE_STRATEGY: { title: "Rekabet Stratejisi", content_text: text_dic.COMPETITIVE_STRATEGY, max_chars: 3000 },
            MARKET_BARRIERS: { title: "Engelleyici Faktörler", content_text: text_dic.MARKET_BARRIERS, max_chars: 3000 },
            VALUE_PROPOSITION: { title: "Değer Önerisi ve Teknolojik Rekabet", content_text: text_dic.VALUE_PROPOSITION, max_chars: 3000 },
            SOCIAL_IMPACT: { title: "Proje ile Sağlanacak Sosyal Fayda", content_text: text_dic.SOCIAL_IMPACT, max_chars: 3000 },
            ENVIRONMENTAL_IMPACT: { title: "Çevreye ve Canlılara Etki", content_text: text_dic.ENVIRONMENTAL_IMPACT, max_chars: 3000 }
        },
    },
    D2: {
        title: "Ürün Satışı ve Ticarileşme Öngörüleri",
        content: {
            NATIONAL_BENEFIT: { title: "Projenin Sağlayabileceği Ulusal Kazanımlar", content_text: text_dic.NATIONAL_BENEFIT, max_chars: 3000 }
        },
    },
    D3: {
        title: "Kaynak Yönetimi",
        content: {
            RESOURCE_REQUIREMENTS: { title: "Kaynak İhtiyacı", content_text: text_dic.RESOURCE_REQUIREMENTS, max_chars: 4000 },
            PUBLIC_FUNDING: { title: "Ek Kamu Desteği", content_text: text_dic.PUBLIC_FUNDING, max_chars: 4000 },
            MANUFACTURING_INVESTMENT: { title: "Seri Üretim ve Yatırım İhtiyacı", content_text: text_dic.MANUFACTURING_INVESTMENT, max_chars: 4000 },
            STRATEGIC_PARTNERSHIPS: { title: "İşbirliği Yapılması Gereken Paydaşlar", content_text: text_dic.STRATEGIC_PARTNERSHIPS, max_chars: 4000 }
        },
    },
    E1: {
        title: "Risk ve Finansman Yönetimi",
        content: {
            RISKS: { title: "Projenin Yürütülmesi Sırasında Karşılaşılabilecek Riskler ve Alınacak Önlemler", content_text: text_dic.RISKS, max_chars: 5000 }
            //RISKS_COMMER: { title: "Proje Çıktısının Ticarileşmesi Aşamasında Karşılaşılabilecek Riskler ve Alınacak Önlemler", content_text: text_dic.RISKS_COMMER, max_chars: 5000 }
        },
    }
  });
  
  export default generateSectionsData;

    